/*! @azure/msal-browser v5.18.0 2026-08-04 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
const contentError = "ContentError";
const pageException = "PageException";
const userSwitch = "user_switch";
const unsupportedMethod = "unsupported_method";

export { contentError, pageException, unsupportedMethod, userSwitch };
//# sourceMappingURL=NativeAuthErrorCodes.mjs.map
